'use strict'

import {bootstrap} from '../bootstrap/bootstrap'
import {attachHandlers} from './handlers'
import {loadInsight} from './insights'
import {InsightsDataCache} from './cache'
const insightsSegments = document.querySelectorAll('.insights-segments')[0]

bootstrap(insightsSegments, insightsSegments => {
  const insightsType = insightsSegments.getAttribute('data-insights-type')
  const card = insightsSegments.querySelector('.card')

  card.classList.add('card--bounce')
  card.classList.add(insightsType)

  if (insightsType === 'segments--trends') {
    document.querySelector('.line--two').classList.add('line--red')
    document.querySelector('.line--three').classList.remove('line--red')
  }

  const insightsDataCache = new InsightsDataCache(insightsType)
  insightsDataCache.getItems().then(() => {
    loadInsight(insightsDataCache)
    attachHandlers(insightsSegments, insightsDataCache)
  })
})
